import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Linkedin, MapPin, Phone, Mail } from 'lucide-react';
import { useSite } from '../context/SiteContext';

export default function Footer() {
  const { settings } = useSite();
  const c = {
    name: settings?.companyName || 'Terra Homes Realty',
    tagline: settings?.tagline || 'Your Home, Our Goal',
    address: settings?.address || '',
    mobile: settings?.mobile || '',
    email: settings?.email || '',
    logo: settings?.logo || '/assets/logo.png',
    facebook: settings?.facebook || '#',
    instagram: settings?.instagram || '#',
    twitter: settings?.twitter || '#',
    linkedin: settings?.linkedin || '#'
  };
  return (
    <footer className="bg-neutral-950 text-neutral-300 mt-20">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <img src={c.logo} alt={c.name} className="h-14 w-auto bg-white p-1 rounded mb-4" />
          <p className="text-sm text-neutral-400 leading-relaxed">{c.tagline}. Helping Filipino families and investors find their perfect property.</p>
          <div className="flex gap-3 mt-5">
            <a href={c.facebook} className="p-2 bg-neutral-800 hover:bg-[#DC2626] rounded-full transition-colors" aria-label="Facebook"><Facebook className="w-4 h-4" /></a>
            <a href={c.instagram} className="p-2 bg-neutral-800 hover:bg-[#DC2626] rounded-full transition-colors" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
            <a href={c.twitter} className="p-2 bg-neutral-800 hover:bg-[#DC2626] rounded-full transition-colors" aria-label="Twitter"><Twitter className="w-4 h-4" /></a>
            <a href={c.linkedin} className="p-2 bg-neutral-800 hover:bg-[#DC2626] rounded-full transition-colors" aria-label="LinkedIn"><Linkedin className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Properties</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/properties/for-sale/house" className="hover:text-white">House for Sale</Link></li>
            <li><Link to="/properties/for-sale/condominium" className="hover:text-white">Condominium for Sale</Link></li>
            <li><Link to="/properties/for-sale/land" className="hover:text-white">Land for Sale</Link></li>
            <li><Link to="/properties/for-sale/commercial" className="hover:text-white">Commercial for Sale</Link></li>
            <li><Link to="/properties/for-rent/house" className="hover:text-white">House for Rent</Link></li>
            <li><Link to="/properties/for-rent/condominium" className="hover:text-white">Condo for Rent</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/agents" className="hover:text-white">Our Advisors</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog & News</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            {c.address && <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#DC2626] flex-shrink-0" /><span>{c.address}</span></li>}
            {c.mobile && <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#DC2626]" /><a href={'tel:' + c.mobile}>{c.mobile}</a></li>}
            {c.email && <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#DC2626]" /><a href={'mailto:' + c.email}>{c.email}</a></li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-800">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center text-xs text-neutral-500">
          <span>{'\u00A9'} {new Date().getFullYear()} {c.name}. All rights reserved.</span>
          <div className="flex gap-4 mt-2 md:mt-0">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms of Service</a>
            <Link to="/admin/login" className="hover:text-white">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
